import { log, warn } from 'dashboard-js/providers/DebuggingProvider'
import SessionStore from 'dashboard-js/providers/SessionStore'
import forEach from 'lodash/forEach'
import pickBy from 'lodash/pickBy'

export default {
    created() {
        if (this.getSaveStateConfig().autoSave) {
            Vue.nextTick(this.saveState) // Wait a tick to make sure that parent have loaded if needed
        }
    },

    methods: {
        attributeIsManagedBySaveState(attribute) {
            if (
                this.getSaveStateConfig().ignoreProperties &&
                this.getSaveStateConfig().ignoreProperties.indexOf(attribute) !== -1
            ) {
                return false
            }

            if (!this.getSaveStateConfig().saveProperties) {
                return true
            }

            return this.getSaveStateConfig().saveProperties.indexOf(attribute) !== -1
        },

        clearSavedState() {
            SessionStore.remove(this.getSaveStateConfig().cacheKey)
        },

        getCacheKey() {
            return this.$options._componentTag
        },

        getSaveStateConfig() {
            return {
                autoSave: true,
                cacheKey: this.getCacheKey(),
            }
        },

        loadState() {
            const savedState = SessionStore.get(this.getSaveStateConfig().cacheKey)

            if (!savedState) {
                warn('Failed to load state', this.getSaveStateConfig().cacheKey)
                return false
            }

            forEach(savedState, (value, key) => {
                if (this.attributeIsManagedBySaveState(key)) {
                    if (this.getSaveStateConfig().onLoad) {
                        value = this.getSaveStateConfig().onLoad(key, value)
                    }

                    this.$data[key] = value
                }
            })

            log('Successfully loaded state', this.getSaveStateConfig().cacheKey, savedState)
            return true
        },

        saveState() {
            const data = pickBy(this.$data, (value, attribute) => {
                return this.attributeIsManagedBySaveState(attribute)
            })

            SessionStore.set(this.getSaveStateConfig().cacheKey, data)
        },
    },
}
